/* eslint-disable react/prop-types */
/* eslint-disable jsx-a11y/label-has-associated-control */
import React, { useState, useRef, useEffect } from 'react';
import PropTypes from 'prop-types';
import FormValidation from '../../atoms/formEnums/formValidation';
import InputText from '../../atoms/inputText/inputText';
import InputTag from '../../atoms/inputTag/inputTag';
import Label from '../../atoms/label/label';
import { IconType } from '../../atoms/icon/icon';
import Button, { ButtonTheme, ButtonType } from '../../atoms/button/button';
import './formTagsPreview.scss';
import LoadFromCatalogButton from '../../molecules/loadFromCatalogButton/loadFromCatalogButton';
import { unset } from 'lodash';
import FormPopup from '../formPopup/formPopup';
import FormInputTypes from '../../atoms/formEnums/formInputTypes';
import ModalBootstrap from 'react-bootstrap/Modal';
import { httpGet } from '../../../store/externalCalls/httpCalls';
import Select from '../../atoms/select/select';
import PosterPreview from './posterPreview';
import ExtendedInfoPreview from './extendedInfoPreview';
export const FormInputTextType = {
  TEXT: 'text',
  COLOR: 'color',
  TIME: 'time',
  EMAIL: 'email',
  NUMBER: 'number',
  PASSWORD: 'password',
  URL: 'url',
  COLOR_PICKER: 'color_picker',
};

/**
 * Form Input Text is a basic HTML input field, label, error text and HelpButton.
 * It is designed to send the input value to a parent component, such as organisms Form,
 * and to shows the validation state of the field provided by the parent component.
 */
const FormTagsPreview = (props) => {
  const {
    id,
    name,
    validation,
    errorText,
    label,
    placeholder,
    helpText,
    value,
    disabled,
    hidden,
    content,
    tagMode
  } = props;

  const childRef = useRef();

  // const [valueState, setValueState] = useState(value !== '' ? value : defaultValue);
  const [valueState, setValueState] = useState(value !== '' ? value : null);
  const [showPreviewPopup,setShowPreviewPopup] =useState(false);
  const [superTitle,setSuperTitle] =useState("Tags preview");
  const [title] =useState(null);
  const [size] =useState("xl");
  const [previewSize,setPreviewSize] =useState("xxl");
  const [previewPurchase,setPreviewPurchase]= useState("-1");
  const [previewSubscription,setPreviewSubscription]= useState("-1");
  const [previewGeorestricted,setPreviewGeorestricted] = useState("no");
  const [previewPosterVisible,setPreviewPosterVisible] =useState(true);
  const [previewExtendedInfoVisible,setPreviewExtendedInfoVisible] =useState(true);
  const [icon] =useState(null);
  const [tags,setTags] =useState({});
  const [images,setImages] =useState({});
  const [extendedInfoImage,setExtendedInfoImage] =useState({});
  const [canPurchase,setCanPurchase] =useState(false);
  const [canSubscribe,setCanSubscribe] =useState(false);
  const [sizesAvailable,setSizesAvailable] =useState([]);
  useEffect(() => {
    if(tagMode=="content"){
      setSizesAvailable([{"name":"xxl","value":"xxl"},{"name":"xlv","value":"xlv"},{"name":"xlh","value":"xlh"},{"name":"lv","value":"lv"},{"name":"lh","value":"lh"},{"name":"m","value":"m"}]);
    }else{
      setSizesAvailable([{"name":"xxl","value":"xxl"},{"name":"xlv","value":"xlv"},{"name":"xlh","value":"xlh"},{"name":"lv","value":"lv"},{"name":"lh","value":"lh"},{"name":"m","value":"m"},{"name":"sv","value":"sv"},{"name":"sh","value":"sh"},{"name":"xs","value":"xs"}]);
    }
  }, [value]);
  const handlerOpenModal=()=>{
    setPreviewSize("xxl");
    setPreviewGeorestricted(false);
    setPreviewPurchase(false);
    setPreviewSubscription(false);
    if(!value){
      alert("You need to save the content first to see this preview");
    }else{
      getTagsPreview(value,"xxl");
      setShowPreviewPopup(true);
    }
  }
  const handleClosePreviewPopup=()=>{
    setShowPreviewPopup(false);
  }
  const getTagsPreview=(contentId,size)=>{
    let tagsPreviewUrl="";
    if(tagMode=="content")
      tagsPreviewUrl="getTagsPreview/"+contentId+"/"+size;
    else
      tagsPreviewUrl="getRoomTagsPreview/"+contentId+"/"+size;
    httpGet(tagsPreviewUrl).then((res)=>{
      let tags=res.tags;
      if(tags.poster && tags.poster.defaultTags){
        let foundPurchase = tags.poster.defaultTags.find((element=>element.name=="Purchase-on"));
        if(foundPurchase){
          setCanPurchase(true);
        }else{
          setCanPurchase(false);
        }
        let foundSubscription = tags.poster.defaultTags.find((element=>element.name=="Subscription-on"));
        if(foundSubscription){
          setCanSubscribe(true);
        }else{
          setCanSubscribe(false);
        }
      }
      setTags(res["tags"]);
      setImages(res["images"]);
      if(tagMode=="content")
        setExtendedInfoImage(res["extendedInfoImage"]);
      
    }).catch(error=>{
      console.log("unknown error ",error);
    });
  }
  const handlerOnChangeSize=(element)=>{
    setPreviewSize(element.target.value);
    getTagsPreview(value,element.target.value);
  }
  const handlerOnChangePurchase=(element)=>{
    setPreviewPurchase(element.target.value);
    getTagsPreview(value,previewSize);
  }
  const handlerOnChangeSubscription=(element)=>{
    setPreviewSubscription(element.target.value);
    getTagsPreview(value,previewSize);
  }
  const handlerOnChangeGeorestricted=(element)=>{
    setPreviewGeorestricted(element.target.value);
    getTagsPreview(value,previewSize);
  }
  
  
  return (
    <div className={`form-group row text-${validation} ${(hidden?"form-input-text__hidden":"")}`}>
      { label !== ''
        && (
          <Label helpText={helpText}>{label}</Label>
        )}
        <div className="col-sm-8">
          <Button id={`button-preview`}
            type={ButtonType.BUTTON}
            onClick={() => handlerOpenModal()}
            theme={ButtonTheme.PRIMARY}
          >
            Preview
          </Button>
          <ModalBootstrap dialogClassName={"modal-preview"} size={(!size?'xl':size)}
            show={showPreviewPopup}
            onHide={handleClosePreviewPopup}
          >
            <ModalBootstrap.Header closeButton>
              <ModalBootstrap.Title>
                <>
                  {icon && <div className="modal-popup-inline"><div className="modal-popup-icon">{icon}</div></div>}
                  <div className="modal-popup-inline">
                  {superTitle && <><div>{superTitle}</div><div className="subTitle">{title}</div></>}
                  {!superTitle && <div>{title}</div>}</div>
                </>
              </ModalBootstrap.Title>
            </ModalBootstrap.Header>
            <ModalBootstrap.Body>
              <div>
                <div className="formTagsPreview-filters">
                  <div>
                    <div>size space</div>
                    <Select
                      className="page-title__select"
                      id="size-select"
                      options={sizesAvailable}
                      value={"xxl"}
                      onChange={handlerOnChangeSize}
                      // disabled={disableArea}
                    />
                  </div>
                  {tagMode=="content" && <div>
                    <div>Geo restricted</div>
                    <Select
                      className="page-title__select"
                      id="geo-select"
                      options={[{"name":"No","value":"no"},{"name":"Yes","value":"yes"}]}                      
                      value={"no"}
                      onChange={handlerOnChangeGeorestricted}
                      // disabled={disableArea}
                    />
                  </div>}
                  {tagMode=="content" && <div>
                    <div>Purchased</div>
                    {canPurchase && <Select
                      className="page-title__select"
                      id="purchase-select"
                      options={[{"name":"(Empty)","value":"-1"},{"name":"No","value":"no"},{"name":"Yes","value":"yes"}]}
                      value={"-1"}
                      onChange={handlerOnChangePurchase}
                      // disabled={disableArea}
                    />}
                    {!canPurchase && <div style={{"display":"block"}}>Can´t purchase</div>}
                  </div>}
                  <div>
                    <div>Subscribed</div>
                    {canSubscribe && <Select
                      className="page-title__select"
                      id="subscription-select"
                      options={[{"name":"(Empty)","value":"-1"},{"name":"No","value":"no"},{"name":"Yes","value":"yes"}]}
                      value={"-1"}
                      onChange={handlerOnChangeSubscription}
                      // disabled={disableArea}
                    />}
                    {!canSubscribe && <div style={{"display":"block"}}>Can´t subscribe</div>}
                  </div>
                </div>

                {/* Category content<br/>
                <img style={{"width":"400px"}} src={XtadiumCategoryContent} />
                <hr/> */}
                <div className="formTagsPreview-preview-position">
                  <PosterPreview 
                      visible={previewPosterVisible} 
                      tags={tags["poster"]} 
                      tagMode={tagMode}
                      georestricted={previewGeorestricted} 
                      purchase={previewPurchase} 
                      subscription={previewSubscription} 
                      size={previewSize} 
                      images={(images?images:null)} 
                      name={(content?content.name:"")}/>
                </div>
                {tagMode=="content" && <div className="formTagsPreview-preview-position">
                  <ExtendedInfoPreview 
                      visible={previewExtendedInfoVisible} 
                      tags={tags["extendedInfo"]} 
                      size={previewSize} 
                      name={(content?content.name:"")} 
                      image={extendedInfoImage?extendedInfoImage:null}
                      georestricted={previewGeorestricted} 
                      purchase={previewPurchase} 
                      subscription={previewSubscription} />
                </div>}
              </div>
        </ModalBootstrap.Body>
        <ModalBootstrap.Footer>
          <div> <Button id={`button-preview`}
            type={ButtonType.BUTTON}
            onClick={() => handleClosePreviewPopup()}
            theme={ButtonTheme.SECONDARY}
            >
            Close
          </Button></div>
          {/* <FormPopupFooter id={id} mode={mode} onClose={handleClose} onEdit={handleEdit} onSave={handleSave} onSecondary={handleEdit}/> */}
        </ModalBootstrap.Footer>
      </ModalBootstrap>
      </div>
    </div>
  );
};

FormTagsPreview.propTypes = {
  /**
   * id of input field
   */
  id: PropTypes.string,
  /**
   * Name of input field
   */
  name: PropTypes.string.isRequired,
  /**
   * Defined text errors
   */
  errorText: PropTypes.string,
  /**
   * Name of input attribute
   */
  label: PropTypes.string,
  /**
   * Placeholder inside the HTML input
   */
  placeholder: PropTypes.string,
  /**
   * Input help text
   */
  helpText: PropTypes.string,
  /**
   * Initial input value
   */
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  
};

FormTagsPreview.defaultProps = {
  id: '',
  validation: FormValidation.PENDING,
  errorText: '',
  label: '',
  placeholder: '',
  helpText: '',
  value: '',
};

export default FormTagsPreview;
